// State/slices/CampaignSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CampaignState {
  campaignName: string;
  channel: string;
  template: string;
  selectedShortCode: string;
}

const savedCampaign = sessionStorage.getItem("draftedCampaign");
const initialState: CampaignState = savedCampaign
  ? JSON.parse(savedCampaign)
  : {
      campaignName: "",
      channel: "",
      template: "",
      selectedShortCode: "",
    };

const CampaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setDraftedCampaign: (state, action: PayloadAction<Partial<CampaignState>>) => {
      const updated = { ...state, ...action.payload };
      sessionStorage.setItem("draftedCampaign", JSON.stringify(updated));
      return updated;
    },
    clearDraftedCampaign: () => {
      sessionStorage.removeItem("draftedCampaign");
      return {
        campaignName: "",
        channel: "",
        template: "",
        selectedShortCode: "",
      };
    },
    resetState: () => initialState, 
  },
});

export const { setDraftedCampaign, clearDraftedCampaign,resetState, } = CampaignSlice.actions;
export default CampaignSlice.reducer;
